import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IRuleValidationResult } from '@cbridge-packages/rule';
import { IPricingRule } from './pricingRule.interface';

export namespace PricingRuleAction {
  const actionCreator = actionCreatorFactory('PricingRule');

  export const reload = actionCreator('RELOAD');
  export const loadList = actionCreator.async<void, IPricingRule[], IApiErrorParams>('LOAD_LIST');
  export const update = actionCreator.async<IPricingRule[], IRuleValidationResult[], IApiErrorParams>('UPDATE');
  export const validate = actionCreator.async<IPricingRule[], IRuleValidationResult[], IApiErrorParams>('VALIDATE');
  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
